import React, { useEffect, useState } from "react";
import { Edit, Trash2, Plus, RotateCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "./RegionList.css";

const url = process.env.REACT_APP_BACKEND_URL;

const RegionList = () => {
  const [regions, setRegions] = useState([]);
  const [showInactive, setShowInactive] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchRegions = async () => {
    try {
      setLoading(true);
      const endpoint = showInactive
        ? `${url}/api/regions/all`
        : `${url}/api/regions`;
      const res = await axios.get(endpoint);
      setRegions(res.data.data || []);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to fetch regions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRegions();
  }, [showInactive]);

  const handleSoftDelete = async (id) => {
    if (window.confirm("Are you sure you want to deactivate this region?")) {
      try {
        const res = await axios.delete(`${url}/api/regions/${id}`);
        toast.success(res.data.message || "Region deactivated successfully");
        fetchRegions();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to deactivate region");
      }
    }
  };

  const handleRestore = async (id) => {
    if (window.confirm("Are you sure you want to activate this region?")) {
      try {
        const res = await axios.put(`${url}/api/regions/${id}/restore`);
        toast.success(res.data.message || "Region activated successfully");
        fetchRegions();
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to activate region");
      }
    }
  };

  if (loading) return <div className="loading">Loading regions...</div>;

  return (
    <div className="region-container">
      <div className="header">
        <h2>Regions List</h2>
        <div className="header-actions">
          <button
            onClick={() => setShowInactive(!showInactive)}
            className={`toggle-button ${showInactive ? 'active' : ''}`}
          >
            {showInactive ? 'Showing All' : 'Show Active Only'}
          </button>
          <button
            onClick={() => navigate("/regions/add")}
            className="add-button"
          >
            <Plus size={16} /> Add Region
          </button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="region-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Region Name</th>
              <th>Country</th>
              {/* <th>Code</th> */}
              <th>Status</th>
              <th style={{ textAlign: "center" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {regions.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">
                  No regions found
                </td>
              </tr>
            ) : (
              regions.map((region, index) => (
                <tr key={region._id} className={region.status === 'inactive' ? 'inactive-row' : ''}>
                  <td>{region.no || index + 1}</td>
                  <td className="region-name">{region.name}</td>
                  <td>{region.country?.name || "N/A"}</td>
                  {/* <td>{region.code || "N/A"}</td> */}
                  <td>
                    <span className={`status-badge ${region.status}`}>
                      {region.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="actions-cell">
                    <div className="actions">
                      {region.status === 'active' ? (
                        <>
                          <button
                            onClick={() => navigate(`/regions/edit/${region._id}`)}
                            className="edit"
                            title="Edit"
                          >
                            <Edit size={16} />
                          </button>
                          <button
                            onClick={() => handleSoftDelete(region._id)}
                            className="delete"
                            title="Deactivate"
                          >
                            <Trash2 size={16} />
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => handleRestore(region._id)}
                          className="restore-btn"
                          title="Activate"
                        >
                          <RotateCcw size={16} /> Activate
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RegionList;